export type SavedAd = {
  id: number;
  board_id: number;
  fb_ad_id: string;
  created_on: string;
  updated_on: string;
  fb_ad: string;
};

export type FbAd = {
  id: number;
  start_date: string;
  end_date: string;
  ad_image: string | null;
  ad_video: string;
  cta: string;
  platform: string;
  ad_link: string;
  is_active: number;
  is_manually_featured: number;
  brand_id: number;
  brand_site: string;
  profile_image: string;
  brand_name: string;
  page_likes: number;
  ad_status: string;
  duration: string;
  media_type: string;
  brand_about: string;
  brand_facebook_about: string;
  brand_description: string;
  brand_category: string;
  ad_content: string;
  ad_country: string;
  ad_creative_id: string;
  adarchiveid: string;
  agegenderdata: string;
  collationcount: string;
  collationid: string;
  creation_time: string;
  cta_type: string;
  data_insert_timestamp: string;
  display_format: string;
  enddate: string;
  html: string;
  image: string;
  impressions: string;
  is_featured: boolean;
  isactive: number;
  link_description: string;
  link_url: string;
  locationdata: string;
  page_categories: string;
  page_id: string;
  pinned_at: string;
  publisherplatform: string;
  reachestimate: string;
  spend: string;
  startdate: string;
  title: string;
  video_content_url: string;
  video_preview_image_url: string;
  video_url: string;
  serpstat_json: string;
  serpstat_keywords: string;
  serpstat_ad_keywords: string;
  load_time: string;
  ad_id: number;
};

export interface TrendingAd {
  ad_content: string;
  ad_id: string;
  ad_image: string;
  ad_link: string;
  ad_video: string;
  brand_name: string;
  brand_id: number;
  brandsite: string;
  cta: string;
  end_date: string;
  id: string;
  is_active: boolean;
  manually_featured: boolean;
  page_id: string;
  platform: string;
  profileimage: string;
  profile_image: string;
  start_date: string;
  page_categories: string;
  page_likes: number;
}

export enum SortAdsBy {
  "initial" = "initial",
  "latest" = "-start_date",
  "startdate" = "start_date",
  "long_running" = "end_date",
}

export enum AdType {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export enum CtaType {
  instagram = "VIEW_INSTAGRAM_PROFILE",
  LearnMore = "LEARN_MORE",
  WhatsAppMessage = "WHATSAPP_MESSAGE",
  shopNow = "SHOP_NOW",
  signUp = "SIGN_UP",
}

export const ctaTitle = (ctaType: CtaType) => {
  switch (ctaType) {
    case CtaType.LearnMore:
      return "Learn More";
    case CtaType.instagram:
      return "Instagram";
    case CtaType.shopNow:
      return "Show Now";
    case CtaType.WhatsAppMessage:
      return "WhatsApp";
    case CtaType.signUp:
      return "Sign Up";
    default:
      return ctaType;
  }
};

export enum Publishers {
  instagram = "instagram",
  facebook = "facebook",
  messenger = "messenger",
}

export enum TrendingAdsSortOption {
  random = "random",
  StartDateDesc = "-start_date",
  StartDateAsc = "start_date",
  LongestRunning = "long_running_ads",
}

export enum TrendingAdsAllAdsOption {
  Featured = "false",
  All = "true",
}

export enum TrendingAdsActiveStatus {
  Inactive = "Inactive",
  Active = "Active",
  Any = "",
}
